import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class PersonOptionsVM extends CommonOptionVM {
  required?: boolean
  require_media?: boolean
  require_note?: boolean

  constructor(data: Partial<PersonOptionsVM> = {}) {
    super(data)
    this.required = data.required ?? undefined
    this.require_media = data.require_media ?? undefined
    this.require_note = data.require_note ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default PersonOptionsVM